import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=f97e9162&"
import script from "./Menus.vue?vue&type=script&lang=js&"
export * from "./Menus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jogg/jogg-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f97e9162')) {
      api.createRecord('f97e9162', component.options)
    } else {
      api.reload('f97e9162', component.options)
    }
    module.hot.accept("./Menus.vue?vue&type=template&id=f97e9162&", function () {
      api.rerender('f97e9162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menus/Menus.vue"
export default component.exports